<div class="cm-skeleton-team-workload">
  <!-- 2×2 grid of summary cards -->
  <div class="cm-skeleton-team-workload__grid">
    @for (card of [].constructor(cardCount()); track $index) {
      <div class="cm-skeleton-team-workload__card">
        <div class="cm-skeleton-team-workload__card-title">
          <div class="cm-skeleton cm-skeleton--circle cm-skeleton--sm cm-skeleton--{{ animation() }}"></div>
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 40%;"></div>
        </div>
        @for (row of [].constructor(rowsPerCard()); track $index) {
          <div class="cm-skeleton-team-workload__row">
            <div class="cm-skeleton cm-skeleton--circle cm-skeleton--sm cm-skeleton--{{ animation() }}"></div>
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--{{ animation() }}" style="width: 45%;"></div>
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 20%; margin-left: auto;"></div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Team section -->
  <div class="cm-skeleton-team-workload__team-section">
    <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 14rem;"></div>
    @for (row of [].constructor(teamRows()); track $index) {
      <div class="cm-skeleton-team-workload__row">
        <div class="cm-skeleton cm-skeleton--circle cm-skeleton--sm cm-skeleton--{{ animation() }}"></div>
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--{{ animation() }}" style="width: 30%;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 35%; height: 0.75rem; margin-left: auto;"></div>
      </div>
    }
  </div>
</div>
